<template>
  <div class="mod-act__task">
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <!-- 查询条件 流程名称(select带搜索)，任务名称input，发起人input，发起时间，到达时间 -->
        <el-row class="margb10">
          <!-- 任务名称 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('activiti.missionName')">
              <el-input v-model="dataForm.taskName"
                        type="text"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 流程名称 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('activiti.processName')">
              <el-select v-model="dataForm.processName"
                         clearable>
                <el-option v-for="(item,index) in processArr"
                           :key="index"
                           :label="item.activityName"
                           :value="item.activityName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 被处理人公司 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('activiti.sponsorOrg')">
              <el-select v-model="dataForm.orgId"
                         filterable
                         remote
                         clearable
                         :placeholder="$t('user.input')"
                         :remote-method="querySearch">
                <el-option v-for="item in results"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 组织类型 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('position.orgType')">
              <el-select v-model="dataForm.processStartOrgType"
                         :placeholder="$t('position.orgType')"
                         clearable>
                <el-option v-for="(item,index) in newOrgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4"
                  class="fr">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         @click="query()"
                         type="primary">{{ $t('query') }}</el-button>
              <el-button style="margin-bottom: 7px"
                         class="el-back M-search M-margin-l"
                         type="info"
                         @click="reset()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row class="margb10">
            <!-- 发起时间起止 -->
            <el-col :span="10"
                    class="padt5">
              <el-form-item :label="$t('activiti.processInitiationTime')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.startDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('organization.startData')"
                                :end-placeholder="$t('organization.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 到达时间起止 -->
            <el-col :span="10"
                    class="padt5">
              <el-form-item :label="$t('activiti.taskArrivalTime')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.arriveDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('organization.startData')"
                                :end-placeholder="$t('organization.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 被处理人信息 手机号，证件编号，用户ID，姓名 -->
            <el-col :span="10"
                    class="padt5">
              <el-form-item :label="$t('activiti.processedPerson')"
                            style="width: 90%!important;">
                <el-input v-model="dataForm.optUserInfo"
                          type="text"
                          :placeholder="$t('activiti.processedPersonPlaceholder')"
                          clearable>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <el-button class="batch-approval"
                 v-if="$hasPermission('AUTH000092')"
                 @click="batchApprovalShow()"
                 type="primary">{{ $t('activiti.batchApproval') }}</el-button>
      <el-table :data="dataList"
                border
                v-loading="dataListLoading"
                @selection-change="handleSelectionChange"
                style="width: 100%">
        <!-- 批量审批复选框 -->
        <el-table-column type="selection"
                         align="center"
                         :selectable="selectAble"
                         fixed="left">
        </el-table-column>
        <!-- 流程名称 -->
        <el-table-column prop="processName"
                         align="left"
                         width="110"
                         header-align="center"
                         :label="$t('activiti.processName')">
        </el-table-column>
        <!-- 任务名称 -->
        <el-table-column prop="taskName"
                         align="left"
                         width="120"
                         header-align="center"
                         :label="$t('activiti.missionName')">
        </el-table-column>
        <!-- 发起人公司名称 -->
        <el-table-column prop="variables.optUserInfo"
                         align="left"
                         width="250"
                         header-align="center"
                         :formatter="orgNameFormatter"
                         :label="$t('activiti.sponsorOrg')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 发起人用户Id（实际上是userCode） -->
        <el-table-column prop="variables.optUserInfo"
                         align="center"
                         :formatter="applyUserFormatter"
                         width="170"
                         :label="$t('activiti.userId')">
        </el-table-column>
        <!-- 流程发起时间 -->
        <el-table-column prop="variables.processStartDate"
                         align="center"
                         width="200"
                         :label="$t('activiti.processInitiationTime')">
        </el-table-column>
        <!-- 任务到达时间 -->
        <el-table-column prop="createTime"
                         align="center"
                         width="200"
                         :label="$t('activiti.taskArrivalTime')">
        </el-table-column>
        <!-- 驳回标识 -->
        <el-table-column prop="variables.auditStatus"
                         align="center"
                         width=""
                         :label="$t('activiti.dismissalStatus')"
                         :formatter="auditStatus">
        </el-table-column>
        <el-table-column align="center"
                         width="120"
                         :label="$t('handle')"
                         fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}
                <em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="$hasPermission('AUTH000093')"
                                  @click.native="gotoView('approval', scope.row)">{{ $t('activiti.approval') }}</el-dropdown-item>
                <el-dropdown-item v-if="$hasPermission('AUTH000094')"
                                  @click.native="gotoView('view', scope.row)">{{ $t('activiti.viewFlowChart') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-card>
    <!-- 弹窗, 批量操作 -->
    <batch-approval v-if="batchApprovalVisible"
                    ref="batchApproval"
                    @refreshDataList="query"></batch-approval>
    <!-- 查看流程图 -->
    <FlowChartView v-if="viewVisible"
                   ref="flowChartView"></FlowChartView>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-activiti'
import ToggleDiv from '@/components/toggle-div'
import BatchApproval from './batch-approval'
import FlowChartView from './flow-chart-view'
import AesUtil from "@/utils/aes_utils";
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/act/operate/taskListMT',
        getDataListIsPage: true
      },
      dataForm: {
        optUserInfo: '',
        orgId: '',
        userCode: '',
        taskName: '',
        processName: '',
        startDateModify: [],
        startDateStart: '',
        startDateEnd: '',
        arriveDateModify: [],
        arriveDateStart: '',
        arriveDateEnd: '',
        roleTypeVal: '',
        orgType: '',
        userId: '',
        processStartOrgType: ''
      },
      userId: '',
      results: [],
      processArr: [],
      dataListLoading: false,
      isShow: false,
      loginUserId: '',
      loading: false,
      batchApprovalVisible: false,
      viewVisible: false,
      multipleSelection: [], // 多选数组
      orgArr: _this.enums['orgType'],
      // 组织类型
      newOrgType: []
    }
  },
  components: {
    ToggleDiv,
    BatchApproval,
    FlowChartView
  },
  mounted() {
    this.dataForm.roleTypeVal = this.getStorage(this.GLOBAL.USER_DATA).roleTypeVal
    if (this.dataForm.roleTypeVal === '0' || this.dataForm.roleTypeVal === '1') {
      this.dataForm.orgType = ''
    } else {
      this.dataForm.orgType = this.getStorage(this.GLOBAL.USER_DATA).orgType
    }
    this.dataForm.userId = this.getStorage(this.GLOBAL.USER_DATA).userId
    this.userId = this.getStorage(this.GLOBAL.USER_DATA).userId
    if (this.dataForm.roleTypeVal === '0' || this.dataForm.roleTypeVal === '1') { // 默认不需要传递orgId
      this.querySearch('')
      this.query()
    }else if(this.dataForm.roleTypeVal === '3' && this.dataForm.orgType === '10' && this.$hasPermission('ACDC0000002')){
      this.query()
    }else { // 默认传递orgId,如果orgType=60，传递上级orgId
      Promise.all([
        this.querySearch('')
      ]).then(() => {
        if (this.dataForm.orgType === '10' || this.dataForm.roleTypeVal === '20' || this.dataForm.roleTypeVal === '30' || this.dataForm.roleTypeVal === '40') {
          this.dataForm.orgId = this.getStorage(this.GLOBAL.USER_DATA).orgId
        } else if (this.dataForm.orgType === '60') {
          for (let index in this.results) {
            if (this.results[index].orgType === '50') {
              this.dataForm.orgId = this.results[index].orgId
            }
          }
        }
        this.query()
      })
    }
    this.newOrgType = JSON.parse(JSON.stringify(this.orgArr))
    if (this.newOrgType.length === 6) {
      // this.newOrgType.splice(3, 2)
      this.newOrgType.splice(4, 1)
    }
  },
  activated() {
    this.$request.get('/sys/commuser/userInfo').then((res) => {
      this.loginUserId = res.user.userId
    }).catch((err) => {
      console.log(err)
    })
    this.getProcess()
    // 广播通知head-menu画面
    this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
  },
  methods: {
    applyUserFormatter(row){
       if (row.variables.optUserInfo) {
        let list = row.variables.optUserInfo.split('-')
        return list[1]
      } else {
        return ''
      }
    },
    // 申请人公司
    orgNameFormatter(row) {
      if (row.variables.optUserInfo) {
        let list = row.variables.optUserInfo.split('-')
        return list[list.length - 1]
      } else {
        return row.variables.optUserInfo
      }
    },
    // table Checkbox方法
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    // 判断复选框是否可以选择，即是否可以批量审批
    selectAble(row) {
      if (row.batchApproval === '10') {
        return true
      } else {
        return false
      }
    },
    // 显示审批弹出框
    batchApprovalShow() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'error',
          showClose: true,
          message: this.$t('activiti.batchApprovalMessage')
        })
      } else {
        this.batchApprovalVisible = true
        this.$nextTick(() => {
          this.$refs.batchApproval.dataForm = this.multipleSelection
          this.$refs.batchApproval.init()
        })
      }
    },
    // 下拉查询公司
    querySearch(queryString) {
      this.$request.get('/sys/org/getOrgList',
        {
          roleTypeVal: this.getStorage(this.GLOBAL.USER_DATA).roleTypeVal,
          orgId: this.getStorage(this.GLOBAL.USER_DATA).orgId,
          name: queryString
        }).then((res, total, code, data) => {
          this.results = res
        }).catch((err) => {
          console.log(err)
        })
    },
    getProcess() {
      // 20220303 调用新接口消除重复
      this.$request.get('/sys/commactivity/listNoDup',
        {
          activitePid: 0
        }
      ).then((res, total, code, data) => {
        this.processArr = res
      }).catch((err) => {
        console.log(err)
      })
    },
    auditStatus(row) {
      if (row.variables.auditStatus === 0) {
        return '驳回'
      } else {
        return ''
      }
    },
    prossTask(row) {
      return row.processStartUserName + this.$t('activiti.initiated') + row.taskName
    },
    query() {
      this.page = 1
      this.getDataListMerge()
      this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
    },
    // 获取列表
    getDataListMerge() {
      this.dataListLoading = true
      if (this.dataForm.startDateModify !== '' && this.dataForm.startDateModify) {
        if (this.dataForm.startDateModify.length === 2) {
          this.dataForm.startDateStart = this.dataForm.startDateModify[0]
          this.dataForm.startDateEnd = this.dataForm.startDateModify[1]
        }
      } else {
        this.dataForm.startDateStart = ''
        this.dataForm.startDateEnd = ''
      }
      if (this.dataForm.arriveDateModify !== '' && this.dataForm.arriveDateModify) {
        if (this.dataForm.arriveDateModify.length === 2) {
          this.dataForm.arriveDateStart = this.dataForm.arriveDateModify[0]
          this.dataForm.arriveDateEnd = this.dataForm.arriveDateModify[1]
        }
      } else {
        this.dataForm.arriveDateStart = ''
        this.dataForm.arriveDateEnd = ''
      }

      if (this.userId === '') {
        this.dataForm.userId = ''
      } else {
        const base64url = require('base64-url')
        let aes = new AesUtil()
        this.dataForm.userId = base64url.encode(aes.encrypt(this.userId + ''))
      }
      this.$request.getAct(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...this.dataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        this.dataList = data.result
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 操作列下拉选项
    gotoView(type, row) {
      // 获取taskInfo中的任务角色
      let userId = ''
      if (this.loginUserId === '') {
        userId = ''
      } else {
        const base64url = require('base64-url')
        let aes = new AesUtil()
        userId = base64url.encode(aes.encrypt(this.loginUserId + ''))
      }
      this.$request.getAct(
        '/act/operate/taskInfoMT',
        {
          taskId: row.taskId,
          userId: userId
        }
      ).then((res, total, code, data) => {
        if (res.code + '' === '2') {
          this.$alert('该待办任务已被其他审批人审批完成，或已撤销').then(
            this.reset()
          )
          return false
        }
        let businessType = ''
        let id = ''
        if (row.businessKey !== '' && row.businessKey) {
          let list = row.businessKey.split('-')
          businessType = list[0]
          id = list[1]
          let query = {
            taskId: row.taskId,
            processId: row.processInstanceId,
            type: businessType,
            approval: 1,
            businessEntrance: '', // 如果不从待办页面进入离职页面，则返回离职列表
            userRole: res.userRoleRef, // 获取任务角色，根据角色显示不同的页面
            pcRegister: '0'
          }
          if (businessType === 'transfer') {
            query.transferId = id
          } else if (businessType === 'dimission') {
            query.dimissionId = id
          } else if (businessType === 'register') {
            const base64url = require('base64-url')
            let aes = new AesUtil()
            query.userId = base64url.encode(aes.encrypt(id + ''))
            // query.userId = id
            // PC端注册
            if (res.variables.pcRegister && res.variables.pcRegister === '1' && res.formKey === 'autoAudit') {
              query.userRole = 'hradminAudit'
              query.pcRegister = '1'
            }
            // if (res.variables.pcRegister && res.variables.pcRegister === '1') {
            //   query.pcRegister = '1'
            // }
          } else if (businessType === 'registerOffering') {
            query.registerOfferingId = id
          } else if (businessType === 'courseDemain') {
            query.courseDemandApplyId = id
          } else if (businessType === 'authApproval') {
            query.authId = id
          } else if (businessType === 'acdcAssessment') {
            query.recruitmentId = id
          } else if (businessType === 'acdcAchievement') {
            query.recruitmentId = id
          }
          if (type === 'approval') {
            if (businessType === 'dimission') { // 离职审批流程
              this.$router.push({
                name: 'task-import-dimission',
                query: query
              })
            } else if (businessType === 'register') { // 注册审批流程
              let register = row.variables.pcRegister;
              // dataForm.processStartOrgType 为10时
              if (register === '2' || this.dataForm.processStartOrgType === '10') {
                this.$router.push({
                  name: 'task-import-register-bmw',
                  query: query
                })
              } else {
                this.$router.push({
                  name: 'task-import-register',
                  query: query
                })
              }
            } else if (businessType === 'transfer') { // 转岗审批流程
              this.$router.push({
                name: 'task-import-transfer',
                query: query
              })
            } else if (businessType === 'registerOffering') { // 排期报名申请
              this.$router.push({
                name: 'task-import-offering',
                query: query
              })
            } else if (businessType === 'courseDemain') { // 开课申请
              this.$router.push({
                name: 'task-import-classbegin',
                query: query
              })
            } else if (businessType === 'authApproval') {
              this.$router.push({
                name: 'task-import-auth-approval',
                query: query
              })
            }  else if (businessType === 'acdcAssessment') {
              console.log('businessType === ')
              this.$request.get(
                '/acdc/recruitment/queryRecruitmentByACT',
                {
                  recruitmentId: query.recruitmentId,
                  page: '1',
                  limit: '10'
                }
              ).then((res, total, code, data) => {
                console.log(' getAssessment  data')
                if(data.data.records[0]){
                  let assessmentForm = data.data.records[0]
                  this.$router.push({
                    name: 'acdc-assessment-assessmentDetail',
                    query: {
                      recruitmentId: assessmentForm.id,
                      userCode: assessmentForm.userCode,
                      recruitmentPosition: assessmentForm.positionName
                    }
                  })
                  this.$eventHub.$emit('showViewAssessmentDetail', '')
                }
              }).catch((err) => {
                console.log(err)
              })


            } else if (businessType === 'acdcAchievement') {
              console.log('businessType === ')
              this.$request.get(
                '/acdc/recruitment/queryRecruitmentByACT',
                {
                  recruitmentId: query.recruitmentId,
                  page: '1',
                  limit: '10'
                }
              ).then((res, total, code, data) => {
                console.log(' getAssessment  data')
                if(data.data.records[0]){
                  let assessmentForm = data.data.records[0]
                  this.$router.push({
                    name: 'acdc-developmentCenter-developmentCenterInfo',
                    query: {
                      recruitmentId: assessmentForm.id,
                    }
                  })
                  this.$eventHub.$emit('showDevelopmentCenterInfo', '')
                }
              }).catch((err) => {
                console.log(err)
              })
            }




            this.$eventHub.$emit(this.GLOBAL.ACTIVATED_UPCOMING, 'activated')
          } else if (type === 'view') {
            this.viewVisible = true
            this.$nextTick(() => {
              this.$refs.flowChartView.processId = row.processInstanceId
              this.$refs.flowChartView.init()
            })
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    reset() {
      this.page = 1
      this.dataForm.optUserInfo = ''
      this.dataForm.orgId = ''
      this.dataForm.userCode = ''
      this.dataForm.taskName = ''
      this.dataForm.processName = ''
      this.dataForm.startDateModify = []
      this.dataForm.startDateStart = ''
      this.dataForm.startDateEnd = ''
      this.dataForm.arriveDateModify = []
      this.dataForm.arriveDateStart = ''
      this.dataForm.arriveDateEnd = ''
      this.dataForm.processStartOrgType = ''
      this.getDataListMerge()
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.el-dropdown-menu {
  width: 120px;
  .el-dropdown-menu__item {
    text-align: center;
    color: #409eff;
  }
}
.batch-approval {
  margin-bottom: 7px;
  overflow: hidden;
  text-align: center;
  min-width: 120px;
}
</style>
